import * as React from 'react'
import Button from '@mui/material/Button'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'

import { terminateUserSession } from 'lib/Helper'
import { useAppSelector } from 'redux/Hook'
import { logout } from 'lib/authentication/Logout'

const useStyles = makeStyles({
  button: {
    color: '#fff',
    '&:hover': {
      color: '#fff',
    },
  },
})

const Logout = () => {
  const classes = useStyles()
  const site = useAppSelector((state) => state.site.site)
  const { t } = useTranslation()

  return (
    <Button
      className={classes.button}
      variant={'contained'}
      onClick={() => terminateUserSession(logout, site)}
    >
      {t(`sidebar.logout`)}
    </Button>
  )
}

export default Logout
